/** Datos identificativos del titular de m4b.news (Xappiens BI SL) */

export const LEGAL = {
  brand: "M4B News",
  siteUrl: "https://m4b.news",
  companyName: "Xappiens BI SL",
  tradeName: "Xappiens",
  cif: "B13894829",
  address: "Calle Salado 5, 30300 Cartagena (Murcia), España",
  city: "Cartagena (Murcia)",
  email: "info@xappiens.com",
  phone: "+34 614 230 720",
  phoneE164: "34614230720",
  companySite: "https://xappiens.com",
  registryNote:
    "Inscrita en el Registro Mercantil. Constitución 07/06/2023. CNAE 6203.",
  updatedAt: "15 de julio de 2026",
  updatedAtIso: "2026-07-15",
} as const;

export const LEGAL_LINKS = [
  { href: "/aviso-legal", label: "Aviso legal" },
  { href: "/terminos", label: "Términos y condiciones" },
  { href: "/privacidad", label: "Privacidad" },
  { href: "/cookies", label: "Cookies" },
  { href: "/precios", label: "Precios" },
] as const;

export type PlanId = "impulso" | "visibilidad" | "liderazgo";

export const PLANS = [
  {
    id: "impulso" as const,
    name: "Impulso",
    description:
      "Ideal para profesionales y pequeñas empresas que inician su presencia digital.",
    priceLabel: "299€",
    priceCents: 29900,
    period: "/mes",
    vatNote: "IVA no incluido",
    features: [
      "Presencia en 3 portales temáticos",
      "Banner combinado (rotación)",
      "10.000 impresiones garantizadas",
      "Informe básico mensual",
      "Soporte por email",
    ],
    highlight: false,
    cta: "Comprar o reservar",
    action: "checkout" as const,
  },
  {
    id: "visibilidad" as const,
    name: "Visibilidad",
    description:
      "Para empresas en crecimiento que buscan destacar sobre la competencia.",
    priceLabel: "599€",
    priceCents: 59900,
    period: "/mes",
    vatNote: "IVA no incluido",
    features: [
      "Presencia en 7 portales estratégicos",
      "Banner fijo en secciones clave",
      "50.000 impresiones garantizadas",
      "Informe detallado de rendimiento",
      "Soporte prioritario",
      "Diseño de banner básico",
      "1 artículo patrocinado trimestral",
    ],
    highlight: true,
    cta: "Comprar o reservar",
    action: "checkout" as const,
  },
  {
    id: "liderazgo" as const,
    name: "Liderazgo",
    description: "Solución corporativa para marcas que dominan su sector.",
    priceLabel: "Consultar",
    priceCents: null,
    period: "",
    vatNote: "Presupuesto a medida",
    features: [
      "Red completa (12+ portales)",
      "Cabecera exclusiva y formatos premium",
      "100.000+ impresiones escalables",
      "Analítica avanzada y ROI",
      "Gestor de cuentas dedicado",
      "Optimización continua de campañas",
      "Contenido patrocinado mensual",
      "Acceso beta a nuevas funcionalidades",
    ],
    highlight: false,
    cta: "Solicitar propuesta",
    action: "contact" as const,
  },
];
